export default {"src":"/_next/static/media/second.8569ad5e.svg","height":333,"width":350,"blurWidth":0,"blurHeight":0};